<router-outlet></router-outlet>
@if (!deviceDetector.isMobile() && siteService.features?.chat) {
    <app-chat-window></app-chat-window>
}
